module.exports = __webpack_public_path__ + "assets/0c5ac4e6250af97b3bdd54cc6103c8fe.png";